import React from "react";
import Header from "../../components/header/index";
// import InnerHeader from '../../components/comment/innerHeader/innerHeader'
import CarBookingContent from "./carbookingcontent/carbookingContent";
import Footer from "../../components/footer";
import InnerHeaderBooking from "./innerheadercar/headerBokingList";

const carbookinglist = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeaderBooking />
      <CarBookingContent />
      <Footer />
    </div>
  );
};

export default carbookinglist;
